module.exports = "https://static-www.niulinkcloud.com/_next/static/media/mobile.408b9c027fc9de1b60a53bcece7ddb23.png";